<template>
  <transition-group name="slide-fade">
    <v-navigation-drawer
      key="drawer"
      v-if="value || $route.matched[$route.matched.length - 1].parent"
      v-model="display"
      :right="right"
      :width="width"
      temporary
      permanent
      fixed
      floating
      class="drawer-box-shadow"
      :style="mr ? 'margin-right:' + mr : ''"
    >
      <v-btn
        class="position-fixed"
        title="Close"
        @click="$emit('close')"
        text
        fab
        small
      >
        <v-icon dark>$close</v-icon>
      </v-btn>
      <router-view
        @exit="exit"
        id="AsideWrapper"
        ref="asideComponent"
        :isDrawer="true"
        :key="$route.fullPath"
        v-bind="data"
        :isRouteView="true"
      />
      <slot v-if="!$refs.asideComponent" name="default" />
      <slot v-if="!$refs.asideComponent" name="child" />
      <template v-slot:append>
        <slot name="append" />
      </template>
    </v-navigation-drawer>
  </transition-group>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    width: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
    mr: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      right: true,
      display: true,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.rightDrawer.opened = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    exit(routeName) {
      if (!routeName) {
        return;
      }
      if (this.$route.from && this.$route.from.name === routeName) {
        this.$router.back();
        return;
      }
      this.$router.push({
        name: routeName,
      });
    },
  },
};
</script>

<style scoped></style>
